import React from 'react';
import App from './App';
import ReactDOM from 'react-dom';
import { LocaleProvider } from './component/AppProvider/LocaleProvider';
import { BrowserRouter, Switch } from 'react-router-dom';

ReactDOM.render(
    <LocaleProvider>
        <BrowserRouter>
            <Switch>
                <App/>
            </Switch>
        </BrowserRouter>
     </LocaleProvider>,
    document.getElementById('root')
);
